export default __webpack_public_path__ + "static/media/download-all.a2448c2d.svg";